"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readContract = void 0;
const chain_1 = require("../utils/chain");
const readContract = ({ chainName, contractDetails, rpcUrl, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const wallet = new chain_1.ChainController(chainName, rpcUrl);
        const res = yield wallet.readContract(contractDetails);
        return res;
    }
    catch (err) {
        console.error(err);
        return { success: false, message: 'Error in readContract', error: err };
    }
});
exports.readContract = readContract;
